export default __webpack_public_path__ + "static/media/DSC_8006-edited-darker.ef37a952.png";